const doc = [({"en":({"js":({"reimbursements":({"documents":({"attachment_library":"Attachment library"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;